import {Cureus} from '../Cureus';

Cureus.AvatarUploaderForm = {}
//= require_tree ./AvatarUploaderForm